import { FilterFormFieldStrategyType } from "@/common/types";
import { diaInterfaceTechOptions } from "../filter-options";

const iptFilterByProduct: FilterFormFieldStrategyType[] = [
  {
    key: "Interface",
    element: {
      inputType: "checkboxGroup",
      label: "Interface",
      name: "IPT-interface",
      required: false,
      options: diaInterfaceTechOptions,
    },
  },
];
export default iptFilterByProduct;
